import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { dispatcher } from 'dispatcher';
import { path } from 'ramda';

import { IGameVisualConfig } from '@core/js/components/system/App/store/types';
import { useAppSelector } from '@core/js/store/hooks';

import { useRunAtp } from '@interlayer/js/app/components/main/AtpButton/hooks/useRunAtp';
import { useAutoGameLaunch } from '@interlayer/js/app/components/main/Games/hooks/useGameLaunch';
import { ENTER_DRAW_ACTION, PROMO_ACTIONS } from '@interlayer/js/app/components/main/Promotions/constants';
import { TPromotionType } from '@interlayer/js/app/components/main/Promotions/types';
import { useNavigateWithCheckUser } from '@interlayer/js/app/hooks/navigate/useNavigate/useNavigateWithCheckUser';
import { openWindow } from '@interlayer/js/utils/url.util';

export const useHandlerActionClick = ({
    item,
    index,
    config = {}
}: {
    item: TPromotionType;
    index: number;
    config: {
        gameCode?: string;
        action?: string;
        internalLinkUrl?: string;
        externalLinkUrl?: string;
        name?: string;
        type?: string;
        schedule?: string;
    };
}) => {
    const navigate = useNavigateWithCheckUser();
    const gameData = useAppSelector(path(['gamesConfiguration', config.gameCode || ''])) as IGameVisualConfig | undefined;
    const launchGame = useAutoGameLaunch(gameData);
    const { pathname } = useLocation();
    const runAtp = useRunAtp({ name: config.name, type: config.type, schedule: config.schedule });

    return useCallback(() => {
        let { promoLink } = item;

        switch (config.action) {
            case PROMO_ACTIONS.gameLaunch: {
                promoLink = 'launchGame';

                launchGame();
                break;
            }
            case PROMO_ACTIONS.linkToPromo: {
                navigate(promoLink);
                break;
            }
            case PROMO_ACTIONS.internalLink: {
                promoLink = config.internalLinkUrl || '';

                navigate(config.internalLinkUrl);
                break;
            }
            case PROMO_ACTIONS.externalLink: {
                promoLink = config.externalLinkUrl || '';

                openWindow(config.externalLinkUrl, '_blank');
                break;
            }
            case PROMO_ACTIONS.atpLaunch: {
                runAtp();

                break;
            }
            case ENTER_DRAW_ACTION: {
                break;
            }
            default: {
                navigate(item.promoLink);
            }
        }

        if (config.action === ENTER_DRAW_ACTION) {
            return;
        }

        dispatcher.dispatch('promoPosition', {
            page: pathname,
            link: promoLink,
            action: config.action,
            position: index + 1
        });

    }, [config.action, config.externalLinkUrl, config.internalLinkUrl, index, item, launchGame, navigate, pathname, runAtp]);
};
